// extracted by mini-css-extract-plugin
export var emailBlockLink = "_kr-0";